



























import UserList from '@/components/admin/users/List.vue'
import User from '@/models/User'
import { apiV1AdminUsersPath } from '@/rails/routes'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import {saveAs} from 'file-saver'
import * as dayjs from 'dayjs'
import {KeyPair} from '@/types/KeyPair'
import UserListCondition from '@/models/shared/UserListCondition'

@Component(
  {
    components: {
      UserList
    }
  }
)
export default class UserIndex extends PageBase {
  users: Array<User> = []
  userListCondition = new UserListCondition()

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '登録者管理一覧'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.showLoading()
      const users = await axios.get(apiV1AdminUsersPath(this.userSearchParams()))
      this.users = users.data.list.map(m => new User(m))
      this.userListCondition.pagenate = users.data.pagenate
      this.hideLoading()
    } catch (e) {
      console.error(e)
    }
  }

  async download(): Promise<void> {
    try {
      this.showLoading()
      const res = await axios.get(apiV1AdminUsersPath(this.userSearchParams('xlsx')),
        {
          responseType: 'blob'
        })
      const blob = new Blob([res.data])
      saveAs(blob, `users_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`)
      this.hideLoading()
    } catch (e) {
      console.error(e)
    }
  }

  userSearchParams(format?: string): KeyPair {
    const params = this.userListCondition.toParams()
    if (format) {
      params['format'] = format
    }
    return params
  }
}
